module.exports = __webpack_public_path__ + "img/sqmy.16fa83be.png";